import { render, staticRenderFns } from "./CUserCredit.vue?vue&type=template&id=527b446e&"
import script from "./CUserCredit.vue?vue&type=script&lang=js&"
export * from "./CUserCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports